<template>
  <div>
    <vx-card>
      <vs-row vs-justify="center" class="mb-4">
        <h3>Summary</h3>
      </vs-row>
      <template v-if="showGoogleDoc">
        <vs-row vs-justify="flex-end" class="mb-2">
          <GoogleDocActions :url="meetingInstance.googleDocumentUrl" @fullscreen="fullscreenDoc" />
        </vs-row>
        <iframe
          ref="docFrame"
          :src="meetingInstance.googleDocumentUrl"
          class="googleDocFrame"
          frameborder="0"
        />
      </template>
      <Question
        v-else
        v-for="question in step.questions"
        :key="question.id"
        :question="question"
        :isEditable="meetingInstance.isEditable"
      />
    </vx-card>
  </div>
</template>

<script>
import Question from "../MeetingQuestion.vue";
import GoogleDocActions from "./GoogleDocActions.vue";
export default {
  props: ["step", "meetingInstance"],
  components: { Question, GoogleDocActions },
  methods: {
    fullscreenDoc() {
      const frame = this.$refs.docFrame;
      if (!frame) return;
      if (document.fullscreenElement) document.exitFullscreen();
      else frame.requestFullscreen();
    }
  },
  computed: {
    showGoogleDoc() {
      const hasNoQuestions = !this.step.questions || this.step.questions.length === 0;
      return hasNoQuestions && !!(this.meetingInstance && this.meetingInstance.googleDocumentUrl);
    }
  }
};
</script>

<style lang="scss" scoped>
.googleDocFrame {
  width: 100%;
  height: 70vh;
  border: 0;
}

@media (min-height: 900px) {
  .googleDocFrame {
    height: calc(100vh - 330px);
  }
}
</style>
